export default "__VITE_ASSET__gguXJm89__"